// maintenance.service.ts
import { Injectable } from '@angular/core';
import { ref, onValue } from 'firebase/database';
import { BehaviorSubject } from 'rxjs';
import { FireRealtimeService } from '@viso/core/data-access';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  maintenanceEnabled = new BehaviorSubject<boolean>(false);
  maintenanceMessage = new BehaviorSubject<string>('');

  constructor(private fireRealtimeService: FireRealtimeService) {
    const db = fireRealtimeService.db;
    const maintenanceRef = ref(db, 'maintenance');

    onValue(maintenanceRef, (snapshot) => {
      const data = snapshot.val();
      this.maintenanceEnabled.next(data?.enabled ?? false);
      this.maintenanceMessage.next(data?.message ?? '');
    });
  }
}
